import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';

import { Copyright } from '../../Copyright';
import { ContactsHemera } from './Contacts';
import {
  CompanyInfoStyled,
  FooterStyled,
  IconStyled,
} from './FooterHemera.styles';

export const FooterHemera = ({ id, className }) => {
  const currentTheme = useTheme();
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  return (
    <>
      <FooterStyled id={id ?? 'footer'} className={className ?? null}>
        {isDesktop && (
          <CompanyInfoStyled>
            <IconStyled iconI={currentTheme.customLogo.clogo} />
          </CompanyInfoStyled>
        )}
        <ContactsHemera />
      </FooterStyled>

      <Copyright />
    </>
  );
};

FooterHemera.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
};
